<template>
<v-dialog
  v-model="show"
  persistent
  max-width="600px"
  transition="dialog-bottom-transition"
>
<v-card>
  <v-toolbar dark color="accent">
    <v-btn icon dark @click="show = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <v-toolbar-title>Toelichting</v-toolbar-title>
    <v-spacer></v-spacer>
  </v-toolbar>
  <div class="ma-10">
    DGA-geleid: Eén familielid heeft leiding, zeggenschap en eigendom in handen <br /><br />
    Familie-geleid variant 1: Meerdere familieleden hebben leiding, zeggenschap en eigendom in handen.<br /><br />
    Familie-geleid variant 2: Leiding, zeggenschap en eigendom is in handen van meerdere familieleden, waarbij beperkingen gelden qua zeggenschap voor één of meerdere familieleden.<br /><br />
    Familie-gecontroleerd: Vele familieleden hebben een eigendomsbelang, maar zij zijn (nog) niet (operationeel) betrokken bij het familiebedrijf en hebben een beperkte zeggenschap.<br /><br />
  </div>
  <v-divider />
</v-card>
</v-dialog>
</template>

<script>
export default {
  props: ["visible"],
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>

<style scoped></style>
